
/**
 * ProductTeaserContainer Component (mirrors TeaserContainer logic, with product class names)
 */
// eslint-disable-next-line sonarjs/cognitive-complexity
const ProductTeaserContainer = teaserContainer => {
  const dataItemsInRowToLoadSelector = '[data-itemsinrowtoload]';
  const loadMoreButton = teaserContainer.querySelector('.cmp-productteasercontainer__button');
  const teaserCardSelector = '.cmp-product-teaser, .cmp-teaser';
  // Hybrid: support both product teaser items and generic teaser/basicpage items
  const teasers = teaserContainer.querySelectorAll('.product-teaser, .teaser, .basicpage');
  const itemsInRowToLoad = teaserContainer.querySelector(dataItemsInRowToLoadSelector)
    ? Number.parseInt(teaserContainer.querySelector(dataItemsInRowToLoadSelector).dataset.itemsinrowtoload, 10)
    : 0;
  const rowsToLoad = teaserContainer.querySelector(dataItemsInRowToLoadSelector)
    ? Number.parseInt(teaserContainer.querySelector('[data-rowstoload]').dataset.rowstoload, 10)
    : 0;

  const hiddenButtonClassName = 'cmp-productteasercontainer__button--hidden';
  const hiddenTeaserClassName = 'cmp-teaser--hidden';

  let visibleTeasersNumber = itemsInRowToLoad * rowsToLoad;

  /**
   * Show necessary number of teasers on page load or on the 'Load more' button click
   */
  const updateTeasersVisibility = () => {
    // Only count valid teaser cards when deciding visibility; non-card nodes stay hidden and don't consume slots
    let slotIndex = 0;
    teasers.forEach(teaser => {
      // Treat as a valid card if it contains either a product teaser card or a generic teaser card
  const hasCard = teaser.querySelector(teaserCardSelector);
      if (hasCard) {
        if (slotIndex < visibleTeasersNumber) {
          teaser.classList.remove(hiddenTeaserClassName);
        } else {
          teaser.classList.add(hiddenTeaserClassName);
        }
        slotIndex += 1;
      } else {
        // Non-card node: keep it hidden but don't consume the visible slot
        teaser.classList.add(hiddenTeaserClassName);
      }
    });
  };

  /**
   * Hide the 'Load more' button if all teasers are visible, otherwise display it
   */
  const updateLodeMoreButtonVisibility = () => {
    const teaserSpacingOnLastPage = 'cmp-teasercontainer--is-on-last-page';
    // Hybrid: count both product teaser cards and generic teaser cards
  const totalCards = teaserContainer.querySelectorAll(teaserCardSelector).length;
    const allVisible = visibleTeasersNumber >= totalCards;
    if (loadMoreButton) {
      if (!allVisible) {
        loadMoreButton.classList.remove(hiddenButtonClassName);
        teaserContainer.classList.remove(teaserSpacingOnLastPage);
      } else {
        loadMoreButton.classList.add(hiddenButtonClassName);
        teaserContainer.classList.add(teaserSpacingOnLastPage);
      }
    }
  };

  /**
   * Show necessary number of teasers and the 'Load more' button if it's needed
   */
  const updateVisibility = () => {
    updateTeasersVisibility();
    updateLodeMoreButtonVisibility();
  };

  /**
   * Load more teasers on the 'Load more' button click
   */
  const loadMoreTeasers = () => {
    visibleTeasersNumber += itemsInRowToLoad * rowsToLoad;
    updateVisibility();
  };

  /**
   * initialize
   */
  const init = function () {
    updateVisibility();
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', () => {
        loadMoreTeasers();
        // If everything is now visible, hide the button (>= to handle exact match)
  const totalCards = teaserContainer.querySelectorAll(teaserCardSelector).length;
        if (visibleTeasersNumber >= totalCards) {
          loadMoreButton.classList.add(hiddenButtonClassName);
        }
      });
    }
  };

  return { init };
};

export { ProductTeaserContainer }
